var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.354,
    height: 20.461,
    viewBox: "0 0 11.354 20.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(3.938 17.361)",
    fill: "#3dd037"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    fill: "#3dd037"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(0 4.34)",
    fill: "#3dd037"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(0 8.68)",
    fill: "#3dd037"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(0 13.021)",
    fill: "#3dd037"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(3.938)",
    fill: "#3dd037"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(3.938 4.34)",
    fill: "#3dd037"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(3.938 8.68)",
    fill: "#3dd037"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(3.938 13.021)",
    fill: "#3dd037"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(8.253)",
    fill: "#3dd037"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(8.253 4.34)",
    fill: "#3dd037"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(8.253 8.68)",
    fill: "#3dd037"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.55,
    cy: 1.55,
    r: 1.55,
    transform: "translate(8.253 13.021)",
    fill: "#3dd037"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneGreen);
export default __webpack_public_path__ + "static/media/phone-green.e5e8124f567f02f2fe67b9bb89792f01.svg";
export { ForwardRef as ReactComponent };